import { Modal, Button, Image } from "semantic-ui-react";
const MediaPreview = ({ mediaUrl, type, isOpen, onClose, t }) => {
  return (
    <Modal open={isOpen} onClose={onClose} size="large">
      <Modal.Content>
        {mediaUrl ? (
          type.includes("video") ? (
            <video controls style={{ width: "100%", maxHeight: "80vh" }} autoPlay>
              <source src={mediaUrl} type="video/mp4" />
              <track kind="captions" src="" default />
              Your browser does not support the video tag.
            </video>
          ) : (
            <Image
              src={mediaUrl}
              alt="Preview"
              style={{ width: "100%", maxHeight: "80vh", objectFit: "contain" }}
            />
          )
        ) : (
          <p>Failed to load media.</p>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" onClick={onClose}>
          {t("close")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default MediaPreview;
